import React from 'react'
import { Source } from 'enums'
import { PostMetric } from 'schemas/PostMetricSchema'
import { PanelContainer } from './shared.css'
import {
  DefaultPanel,
  FacebookPanel,
  ForumPanel,
  InstagramPanel,
  NewsPanel,
  TwitterPanel,
  VocPanel,
  YoutubePanel,
  TiktokPanel,
  PodcastPanel
} from './panels'

interface EngagementsPanelProps {
  data: PostMetric
}
const EngagementsPanel = ({ data }: EngagementsPanelProps) => {
  const { dataStreams, dataset, sourceType } = data
  const nonNullableDataset = dataset || []
  const dataStream = dataStreams?.[0]

  let displayedPanel: JSX.Element
  switch (sourceType) {
    case Source.TWITTER:
      displayedPanel = <TwitterPanel data={nonNullableDataset} />
      break
    case Source.FACEBOOK:
      displayedPanel = <FacebookPanel data={nonNullableDataset} />
      break
    case Source.INSTAGRAM:
      displayedPanel = <InstagramPanel data={nonNullableDataset} />
      break
    case Source.YOU_TUBE:
      displayedPanel = <YoutubePanel data={nonNullableDataset} />
      break
    case Source.TIKTOK:
      displayedPanel = <TiktokPanel data={nonNullableDataset} />
      break
    case Source.FORUMS:
      displayedPanel = <ForumPanel data={nonNullableDataset} dataStream={dataStream} />
      break
    case Source.NEWS:
      displayedPanel = <NewsPanel data={nonNullableDataset} />
      break
    case Source.INTERNAL:
      displayedPanel = <VocPanel data={nonNullableDataset} />
      break
    case Source.PODCAST:
      displayedPanel = <PodcastPanel data={nonNullableDataset} />
      break
    default:
      displayedPanel = <DefaultPanel data={nonNullableDataset} />
      break
  }

  return <PanelContainer>{displayedPanel}</PanelContainer>
}
export default EngagementsPanel
